import React from 'react';
import { Container, Row } from 'reactstrap';
import PropTypes from 'prop-types';

import { color } from '~/assets/styles/colors';
import packageJson from '../../../package.json';

function Footer(props) {
	const { default: isDefault, fluid } = props;

	return (
		<footer
			className={`footer ${isDefault ? ' footer-default' : ''}`}
			style={{ background: color.primary }}>
			<Container fluid={!!fluid}>
				<Row>
					<nav className="footer-nav" />
					<div className="credits ml-auto">
						<span className="copyright">
							{` ${1900 + new Date().getYear()}, Lucree - v${
								packageJson.version
							}`}
						</span>
					</div>
				</Row>
			</Container>
		</footer>
	);
}

Footer.propTypes = {
	default: PropTypes.bool,
	fluid: PropTypes.bool,
};

Footer.defaultProps = {
	default: false,
	fluid: false,
};

export default Footer;
